var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_655_251)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.5 17.5H26.5V2.5C26.5 1.83696 26.2366 1.20107 25.7678 0.732234C25.2989 0.263393 24.663 0 24 0C23.337 0 22.7011 0.263393 22.2322 0.732234C21.7634 1.20107 21.5 1.83696 21.5 2.5V17.5H6.5C5.83696 17.5 5.20107 17.7634 4.73223 18.2322C4.26339 18.7011 4 19.337 4 20C4 20.663 4.26339 21.2989 4.73223 21.7678C5.20107 22.2366 5.83696 22.5 6.5 22.5H21.5V37.5C21.5 38.163 21.7634 38.7989 22.2322 39.2678C22.7011 39.7366 23.337 40 24 40C24.663 40 25.2989 39.7366 25.7678 39.2678C26.2366 38.7989 26.5 38.163 26.5 37.5V22.5H41.5C42.163 22.5 42.7989 22.2366 43.2678 21.7678C43.7366 21.2989 44 20.663 44 20C44 19.337 43.7366 18.7011 43.2678 18.2322C42.7989 17.7634 42.163 17.5 41.5 17.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_655_251",
    x: 0,
    y: 0,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_655_251"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_655_251",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.bc16e510f15ff4d94050e34690f70237.svg";
export { ForwardRef as ReactComponent };